import { useTranslation } from 'react-i18next'
import { Newspaper } from 'lucide-react'
import { cn } from '@/lib/utils'
import { FacebookIcon, ThreadsIcon, XIcon } from '../../../shared/ui/BrandIcons'
import { useScrollReveal } from './useScrollReveal'

export function CoverageSection() {
  const { t } = useTranslation()
  const { ref, isVisible } = useScrollReveal()

  const items = [
    { key: 'facebook', icon: <FacebookIcon size={18} /> },
    { key: 'x', icon: <XIcon size={18} /> },
    { key: 'threads', icon: <ThreadsIcon size={18} /> },
    { key: 'news', icon: <Newspaper size={18} /> },
  ]

  return (
    <section
      id="platform"
      className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24"
    >
      <div ref={ref} className={cn('scroll-reveal', isVisible && 'is-visible')}>
        <div className="mb-10 max-w-2xl">
          <h2 className="m-0 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
            {t('landing.coverage.title')}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">
            {t('landing.coverage.subtitle')}
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item) => (
            <div
              key={item.key}
              className="group flex items-center gap-4 rounded-xl bg-glass p-4 ring-1 ring-glass-ring transition-all duration-200 hover:bg-glass-hover"
            >
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary text-muted-foreground transition-colors duration-200 group-hover:bg-icon-frame group-hover:text-icon-frame-foreground">
                {item.icon}
              </div>
              <div>
                <div className="text-sm font-medium text-foreground">
                  {t(`landing.coverage.sources.${item.key}`)}
                </div>
                <div className="mt-0.5 text-xs text-muted-foreground">
                  {t('landing.coverage.sourceNote')}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
